module.exports = "fragment PlanDescriptionFragment on PlansDescription {\n  __typename\n  id\n  description\n}\n"